import classNames from 'classnames';

import { GridCol, GridRow } from '../grid';
import { Typography } from '../typography';

export interface ItemsListAssignmentProps<T, S> {
  isSubmitting: boolean;
  searchedItems: T;
  SearchedContainerHeader?: React.ReactNode;
  SearchedContainerContent: (searchedItems: T) => React.ReactNode;
  SearchedContainerFooter?: React.ReactNode;
  selectedItems: S;
  selectedLabel: string;
  SelectedContainerContent: (selectedItem: S) => React.ReactNode;
  SelectedContainerFooter?: React.ReactNode;
}

export function ItemsListAssignment<T, S>({
  isSubmitting,
  searchedItems,
  SearchedContainerHeader,
  SearchedContainerContent,
  SearchedContainerFooter,
  selectedItems,
  selectedLabel,
  SelectedContainerContent,
  SelectedContainerFooter,
}: ItemsListAssignmentProps<T, S>) {
  return (
    <div
      className={classNames(
        'flex h-[35rem] px-4 rounded-lg',
        isSubmitting && 'opacity-60 cursor-not-allowed pointer-events-none',
      )}
    >
      <GridRow cols={3} className="flex-1 divide-x gap-2">
        <GridCol className="flex flex-col overflow-hidden" span={2}>
          <div className="px-4 pb-4 h-14 flex items-center">{SearchedContainerHeader}</div>
          <div className="h-full overflow-y-auto flex-1 overflow-hidde  mx-4 rounded-tl-lg rounded-tr-lg border-border border-t border-l border-r">
            {SearchedContainerContent(searchedItems)}
          </div>
          {SearchedContainerFooter != null && (
            <div className="border border-solid border-border rounded-bl-lg rounded-br-lg flex items-center mx-4">
              {SearchedContainerFooter}
            </div>
          )}
        </GridCol>
        <GridCol className="flex flex-col overflow-hidden border-none" span={1}>
          <div className="px-4 h-14 flex items-center" />
          <div className="px-4 rounded-tl-lg rounded-tr-lg bg-surface-elevated h-9 flex items-center">
            <div className="flex flex-1 items-center">
              <Typography className="flex-1" variant="dt">
                {selectedLabel}
              </Typography>
              <span>
                {Array.isArray(selectedItems) && (
                  <Typography variant="none" className="text-brand-primary">
                    {selectedItems.length || 0}
                  </Typography>
                )}
              </span>
            </div>
          </div>
          <div className="p-4 h-full overflow-y-auto flex-1 space-y-3 bg-surface-base border border-border rounded-bl-lg rounded-br-lg">
            {SelectedContainerContent(selectedItems)}
          </div>
          {SelectedContainerFooter != null && (
            <div className="border border-solid border-border flex items-center mx-4">{SelectedContainerFooter}</div>
          )}
        </GridCol>
      </GridRow>
    </div>
  );
}

export default ItemsListAssignment;
